let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2sYHg")).then(() => parcelRequire('e6eQQ'));